module.exports = __webpack_public_path__ + "img/bg10.59b8ab8c.gif";